import { objectWithoutProperties as _objectWithoutProperties } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { IconButton } from '@mui/material';
import MoreHorizIcon from '../../../assets/icons/MoreHoriz.js';

var _excluded = ["children"];

var MenuCellTrigger = function MenuCellTrigger(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? /*#__PURE__*/React.createElement(MoreHorizIcon, null) : _ref$children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(IconButton, props, children);
};

var MenuCellTrigger$1 = MenuCellTrigger;

export { MenuCellTrigger$1 as default };
